import JsEncrypt from 'jsencrypt'

export default {
    install (Vue, opt) {
        Vue.prototype.rsaEncode = function (str, public_key) {
            let encryptor = new JsEncrypt()
            encryptor.setPublicKey(public_key)
            return encryptor.encrypt(str)
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/rsa.js
// module id = null
// module chunks = 